<template>
  <label
    class="inline-flex cursor-pointer items-center"
    :class="{ 'flex-row-reverse justify-end': labelPosition === 'left' }"
  >
    <input
      v-model="value"
      type="checkbox"
      class="peer sr-only"
      :disabled="disabled"
    />
    <div
      class="peer relative shrink-0 rounded-full bg-gray-200 after:absolute after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-indigo-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300"
      :class="sizeClasses"
    />
    <span
      v-if="label"
      class="text-sm text-gray-700"
      :class="labelPosition === 'right' ? 'ml-2' : 'mr-2'"
    >
      {{ label }}
    </span>
  </label>
</template>

<script lang="ts" setup>
type ToggleSize = 'small' | 'base' | 'large';

type LabelPosition = 'left' | 'right';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    default: undefined,
  },
  size: {
    type: String as PropType<ToggleSize>,
    default: 'base' as ToggleSize,
  },
  labelPosition: {
    type: String as PropType<LabelPosition>,
    default: 'right' as LabelPosition,
  },
  disabled: {
    type: Boolean,
  },
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    if (!props.disabled) {
      emit('update:modelValue', newValue);
    }
  },
});

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'small':
      return 'w-9 h-5 after:top-[2px] after:left-[2px] after:h-4 after:w-4';
    case 'base':
      return 'w-11 h-6 after:top-[2px] after:left-[2px] after:h-5 after:w-5';
    default:
      return 'w-14 h-7 after:top-0.5 after:left-[4px] after:h-6 after:w-6';
  }
});
</script>
